import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { logger } from '../../../helpers/logging';
import { HandleMapIconClick } from '../types/types';

import { checkAndReturnArtificialReefIconData } from './mapHelpers';

export const handleArtificialReefClick: HandleMapIconClick = ({
  layerId,
  event,
  map,
  setSelectedIcon,
}) => {
  logger.debug('Icon clicked on map.');
  const latitude = event.lngLat.lat;
  const longitude = event.lngLat.lng;

  const features = map.queryRenderedFeatures(event.point, {
    layers: [layerId],
  });

  if (features.length < 1) {
    throw new Error(
      `No Id was found when clicking that icon - Lat: ${latitude}, Lng: ${longitude}`,
    );
  }

  const artificialReefId = checkAndReturnArtificialReefIconData(features, longitude, latitude);

  void trackEvent({
    name: 'mykiss_explore_marker_clicked',
    properties: {
      type: 'artificial_reef',
    },
  });

  setSelectedIcon({
    drawerViewId: artificialReefId,
    drawerView: 'artificial-reef',
    latitude,
    longitude,
  });
};
